"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = require("react");

var _classnames = _interopRequireDefault(require("classnames"));

var _spauiUtils = require("@tencent/spaui-utils");

var _reactDom = require("react-dom");

var _index = require("./utils/index");

var _overlay_trigger_compact_props = _interopRequireDefault(require("./overlay_trigger_compact_props"));

var _overlay_trigger_props = require("./overlay_trigger_props");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var updateOffsetData = function updateOffsetData() {
  var result = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var moveX = parseInt(state.moveX, 10) || 0;
  var moveY = parseInt(state.moveY, 10) || 0;

  if (_typeof(result) !== 'object' || !result) {
    return {
      top: 0 + moveY,
      left: 0 + moveX
    };
  }

  return _objectSpread({}, result, {
    top: moveY + (parseInt(result.top, 10) || 0),
    left: moveX + (parseInt(result.left, 10) || 0)
  });
};
/**
 * @class
 */


var OverlayTrigger =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(OverlayTrigger, _PureComponent);

  function OverlayTrigger(props) {
    var _this;

    _classCallCheck(this, OverlayTrigger);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(OverlayTrigger).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "isKeyDownClickEvent", function (event) {
      if (event.clientX === 0 && event.clientY === 0 && event.pageX === 0 && event.pageY === 0) {
        return true;
      }

      return false;
    });

    _this.el = (typeof document === "undefined" ? "undefined" : _typeof(document)) === 'object' && document.createElement('div');
    _this.targetAppend = false;
    _this.bodyAppend = false;

    _this.nullList();

    _this.state = {
      placement: props.placement !== 'auto' ? props.placement : props.defaultPlacement,
      show: props.show || false,
      x: 0,
      y: 0,
      width: 0,
      height: 0,
      leftOfOverlay: -9999,
      topOfOverlay: -9999,
      moveX: 0,
      moveY: 0
    };
    _this.handleMouseOut = _this.handleMouseOut.bind(_assertThisInitialized(_this));
    _this.handleDocumentClick = _this.handleDocumentClick.bind(_assertThisInitialized(_this));
    _this.handleTargetScroll = _this.handleTargetScroll.bind(_assertThisInitialized(_this));
    _this.handleWindowResize = _this.handleWindowResize.bind(_assertThisInitialized(_this));
    _this._insideClick = false;
    _this.id = (0, _index.uniqueId)();
    _this.updateOverlayTimeout = null;
    return _this;
  }

  _createClass(OverlayTrigger, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.appendTargetEl();
      this.updateOverlay();
      this.updateDocumentClick();
      this.addScrollListener(); // 监听下页面变化

      if (this.props.autoResize) {
        if (_index.haveJQuery) {
          jQuery(window).on('resize', this.handleWindowResize);
        } else if ((typeof window === "undefined" ? "undefined" : _typeof(window)) === 'object' && (0, _spauiUtils.isFunction)(window.addEventListener)) {
          window.addEventListener('resize', this.handleWindowResize);
        }
      }
    }
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      var _this$props = this.props,
          placement = _this$props.placement,
          defaultPlacement = _this$props.defaultPlacement;

      if (typeof nextProps.show !== 'undefined') {
        this.setState({
          show: nextProps.show
        });
      } // 面板位置有变化就更新下


      if (placement !== nextProps.placement || defaultPlacement !== nextProps.defaultPlacement) {
        this.setState({
          placement: nextProps.placement !== 'auto' ? nextProps.placement : nextProps.defaultPlacement
        });
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      this.appendTargetEl();
      this.updateOverlay(prevProps, prevState);
      this.updateDocumentClick();
      this.addScrollListener();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var target = this.getTarget();
      var body = (0, _index.getBody)();

      try {
        if (typeof _reactDom.createPortal === 'undefined') {
          (0, _reactDom.unmountComponentAtNode)(this.el);
        }

        if (typeof target === 'undefined') {
          body && body.removeChild(this.el);
        } else if (target) {
          target.removeChild(this.el);
        }
      } catch (e) {}

      clearTimeout(this.showDelayTimeOut);
      clearTimeout(this.timeout);
      this.nullList();
      this.removeDocumentClick();
      this.removeScrollListener(); // 销毁的时候必须去掉监听事件，不然性能越来越差

      if (this.props.autoResize) {
        if (_index.haveJQuery) {
          jQuery(window).off('resize', this.handleWindowResize);
        } else if ((typeof window === "undefined" ? "undefined" : _typeof(window)) === 'object' && (0, _spauiUtils.isFunction)(window.removeEventListener)) {
          window.removeEventListener('resize', this.handleWindowResize);
        }
      }

      clearTimeout(this.updateOverlayTimeout);
    } // 回收

  }, {
    key: "nullList",
    value: function nullList() {
      this.popup = null;
      this.timeout = null;
      this.showDelayTimeOut = null;
      this.childRef = null;
    } // 添加对应的结构到页面

  }, {
    key: "appendTargetEl",
    value: function appendTargetEl() {
      var _this$props$disabled = this.props.disabled,
          disabled = _this$props$disabled === void 0 ? false : _this$props$disabled;
      var show = this.state.show;
      var target = this.getTarget();
      var body = (0, _index.getBody)();

      if (show && !disabled) {
        if (typeof target === 'undefined') {
          if (!this.bodyAppend && body) {
            body.appendChild(this.el);
            this.bodyAppend = true;
          }
        } else if (target) {
          if (!this.targetAppend) {
            target.appendChild(this.el);
            this.targetAppend = true;
          }
        }
      }
    } // 更新复层的位置，对外暴露的方法

  }, {
    key: "updateOverlay",
    value: function updateOverlay(prevProps, prevState) {
      var _this2 = this;

      var _this$props2 = this.props,
          _this$props2$popoverA = _this$props2.popoverAnimateTime,
          popoverAnimateTime = _this$props2$popoverA === void 0 ? 0 : _this$props2$popoverA,
          _this$props2$followMo = _this$props2.followMouse,
          followMouse = _this$props2$followMo === void 0 ? false : _this$props2$followMo,
          trigger = _this$props2.trigger,
          _this$props2$disabled = _this$props2.disabled,
          disabled = _this$props2$disabled === void 0 ? false : _this$props2$disabled;
      var show = this.state.show;
      var needUpdate = true; // 防止children结构多层，一直在触发mouseOut导致定位不准

      if (!followMouse && trigger === 'hover' && _typeof(prevProps) === 'object' && prevProps && prevProps.popoverAnimateTime === this.props.popoverAnimateTime && prevProps.offsetData === this.props.offsetData && prevProps.autoPlacementBasic === this.props.autoPlacementBasic && prevProps.overlay === this.props.overlay && prevProps.target === this.props.target && _typeof(prevState) === 'object' && prevState && prevState.show === this.state.show && prevState.placement === this.state.placement) {
        needUpdate = false;
      }

      if (needUpdate && !disabled) {
        // React 15点版本的只能通过这个回收
        if (typeof _reactDom.createPortal === 'undefined') {
          this.renderPortal();
        }

        if (show) {
          // 动画时间为0的，就不做timeout了
          if (popoverAnimateTime < 1) {
            // React15要延迟下不然拿不到结构
            if (typeof _reactDom.createPortal === 'undefined') {
              setTimeout(function () {
                if (_this2 && _this2.setOverlay) {
                  // react 15 下，位置信息延迟后才能拿到，位置信息更新后需要再渲染一下浮层
                  _this2.setOverlay(function () {
                    _this2.renderPortal();
                  });
                }
              }, 4);
            } else {
              this.setOverlay();
            }
          } else {
            this.updateOverlayTimeout = setTimeout(function () {
              if (_this2 && _this2.setOverlay) {
                _this2.setOverlay();
              }
            }, popoverAnimateTime);
          }
        }
      }
    } // 监听页面点击

  }, {
    key: "updateDocumentClick",
    value: function updateDocumentClick() {
      var show = this.state.show;
      var _this$props3 = this.props,
          documentClickAutoHide = _this$props3.documentClickAutoHide,
          _this$props3$disabled = _this$props3.disabled,
          disabled = _this$props3$disabled === void 0 ? false : _this$props3$disabled;

      if (documentClickAutoHide && !disabled) {
        // 需要回收
        if (show && !this.haveDocumentClick) {
          if ((typeof document === "undefined" ? "undefined" : _typeof(document)) === 'object' && (0, _spauiUtils.isFunction)(document.addEventListener)) {
            document.addEventListener('click', this.handleDocumentClick);
          }

          this.haveDocumentClick = true;
        } else if (!show) {
          this.removeDocumentClick();
        }
      }
    } // 去除页面点击

  }, {
    key: "removeDocumentClick",
    value: function removeDocumentClick() {
      var documentClickAutoHide = this.props.documentClickAutoHide;

      if (documentClickAutoHide) {
        if (this.haveDocumentClick) {
          if ((typeof document === "undefined" ? "undefined" : _typeof(document)) === 'object' && (0, _spauiUtils.isFunction)(document.removeEventListener)) {
            document.removeEventListener('click', this.handleDocumentClick);
          }

          this.haveDocumentClick = false;
          this._insideClick = false;
        }
      }
    } // 处理页面点击

  }, {
    key: "handleDocumentClick",
    value: function handleDocumentClick(event) {
      var propsShow = this.props.show;

      var _compactProps = (0, _overlay_trigger_compact_props["default"])(this.props),
          onShow = _compactProps.onShow;

      var show = this.state.show; // 如果不是内部点击，就关闭掉

      if (show && !this._insideClick) {
        // 根据配置延迟下
        clearTimeout(this.timeout);

        if (typeof propsShow === 'undefined') {
          this.setState({
            show: false
          });
        }

        if ((0, _spauiUtils.isFunction)(onShow)) {
          onShow(event, false);
        }
      }

      this._insideClick = false;
    } // 处理对应的目标滚动事件，滚动的时候关闭复层

  }, {
    key: "handleTargetScroll",
    value: function handleTargetScroll(event) {
      var propsShow = this.props.show;

      var _compactProps2 = (0, _overlay_trigger_compact_props["default"])(this.props),
          onShow = _compactProps2.onShow;

      var show = this.state.show;

      if (show) {
        if (typeof propsShow === 'undefined') {
          this.setState({
            show: false
          });
        }

        if ((0, _spauiUtils.isFunction)(onShow)) {
          onShow(event, false);
        }
      }
    } // 添加滚动监听

  }, {
    key: "addScrollListener",
    value: function addScrollListener() {
      var _this$props4 = this.props,
          _this$props4$hideWhen = _this$props4.hideWhenScrolling,
          hideWhenScrolling = _this$props4$hideWhen === void 0 ? false : _this$props4$hideWhen,
          _this$props4$disabled = _this$props4.disabled,
          disabled = _this$props4$disabled === void 0 ? false : _this$props4$disabled;
      var scrollbarTarget = this.props.scrollbarTarget;
      var target = null;

      if (hideWhenScrolling && !disabled) {
        // 先清除之前的监听
        this.removeScrollListener();

        if ((0, _spauiUtils.isFunction)(scrollbarTarget)) {
          scrollbarTarget = scrollbarTarget();
        }

        target = typeof scrollbarTarget !== 'undefined' ? scrollbarTarget || '' : (typeof window === "undefined" ? "undefined" : _typeof(window)) === 'object' && window.document;

        if (target && target.addEventListener) {
          target.addEventListener('scroll', this.handleTargetScroll);
        }
      }
    } // 去除监听

  }, {
    key: "removeScrollListener",
    value: function removeScrollListener() {
      var _this$props$hideWhenS = this.props.hideWhenScrolling,
          hideWhenScrolling = _this$props$hideWhenS === void 0 ? false : _this$props$hideWhenS;
      var scrollbarTarget = this.props.scrollbarTarget;
      var target = null;

      if (hideWhenScrolling) {
        if ((0, _spauiUtils.isFunction)(scrollbarTarget)) {
          scrollbarTarget = scrollbarTarget();
        }

        target = typeof scrollbarTarget !== 'undefined' ? scrollbarTarget || '' : (typeof window === "undefined" ? "undefined" : _typeof(window)) === 'object' && window.document;

        if (target && target.removeEventListener) {
          target.removeEventListener('scroll', this.handleTargetScroll);
        }
      }
    }
  }, {
    key: "handleWindowResize",
    value: function handleWindowResize() {
      var _this$props$disabled2 = this.props.disabled,
          disabled = _this$props$disabled2 === void 0 ? false : _this$props$disabled2;
      var _this$state$show = this.state.show,
          show = _this$state$show === void 0 ? false : _this$state$show;

      if (show && !disabled) {
        this.updateOverlay();
      }
    } // 获取对象节点

  }, {
    key: "getTarget",
    value: function getTarget() {
      var target = this.props.target;
      var result = target;

      if (result === 'parentNode' && this.childRef) {
        result = this.childRef.parentNode;
      }

      return result;
    } // 处理下mouseout事件

  }, {
    key: "handleMouseOut",
    value: function handleMouseOut(event) {
      var _this3 = this;

      var goToPopOverDelayTime = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var show = this.props.show;

      var _compactProps3 = (0, _overlay_trigger_compact_props["default"])(this.props),
          onShow = _compactProps3.onShow,
          hideDelayTime = _compactProps3.hideDelayTime,
          trigger = _compactProps3.trigger;

      var _ref = (0, _index.getChild)(this.props.children, (0, _overlay_trigger_compact_props["default"])(this.props)) || {},
          childProps = _ref.props;

      var _ref2 = childProps || {},
          onMouseOut = _ref2.onMouseOut;

      var placement = this.state.placement;
      var useHideDelayTime = hideDelayTime;
      var eventTargetRect = {};
      var verticalDirection = '';
      var horizontalDirection = ''; // 继承下event

      event && event.persist && event.persist(); // 如果是按钮离开往popover的方向，就要设置最小的延迟时间

      if (trigger === 'hover' && this.state.show && goToPopOverDelayTime > 0 && event && event.target && event.target.getBoundingClientRect) {
        eventTargetRect = event.target.getBoundingClientRect();

        if (eventTargetRect.left + (placement === 'left' ? eventTargetRect.width / 4 : eventTargetRect.width - eventTargetRect.height / 4) > event.clientX) {
          horizontalDirection = 'left';
        } else {
          horizontalDirection = 'right';
        }

        if (eventTargetRect.top + (placement === 'top' ? eventTargetRect.height / 4 : eventTargetRect.height - eventTargetRect.height / 4) > event.clientY) {
          verticalDirection = 'top';
        } else {
          verticalDirection = 'bottom';
        }

        if ((placement === 'top' || placement === 'bottom') && placement === verticalDirection) {
          useHideDelayTime = Math.max(goToPopOverDelayTime, useHideDelayTime);
        } else if ((placement === 'left' || placement === 'right') && placement === horizontalDirection) {
          useHideDelayTime = Math.max(goToPopOverDelayTime, useHideDelayTime);
        }
      } // 根据配置延迟下


      clearTimeout(this.timeout);
      clearTimeout(this.showDelayTimeOut);
      this.timeout = setTimeout(function () {
        if (_this3 && _this3.setState) {
          if (typeof show === 'undefined') {
            _this3.setState({
              show: false
            });
          }

          if ((0, _spauiUtils.isFunction)(onMouseOut)) {
            onMouseOut(event, false);
          }

          if ((0, _spauiUtils.isFunction)(onShow)) {
            onShow(event, false);
          }
        }
      }, useHideDelayTime);
    } // 浮层的内容

  }, {
    key: "popupContent",
    value: function popupContent() {
      var _this4 = this;

      var _this$props5 = this.props,
          overlay = _this$props5.overlay,
          trigger = _this$props5.trigger,
          _this$props5$fixed = _this$props5.fixed,
          fixed = _this$props5$fixed === void 0 ? false : _this$props5$fixed,
          _this$props5$followMo = _this$props5.followMouse,
          followMouse = _this$props5$followMo === void 0 ? false : _this$props5$followMo;
      var _this$state = this.state,
          show = _this$state.show,
          leftOfOverlay = _this$state.leftOfOverlay,
          topOfOverlay = _this$state.topOfOverlay,
          left = _this$state.left,
          top = _this$state.top,
          width = _this$state.width,
          height = _this$state.height,
          placement = _this$state.placement;
      var popupProps = {
        show: show || false,
        className: (0, _classnames["default"])({
          'with-fixed': fixed,
          'with-follow-mouse': trigger === 'hover' && followMouse
        })
      };
      var cssText = ''; // 如果本身有classname要加上

      if (_typeof(overlay) === 'object' && overlay && overlay.props) {
        popupProps.className += " ".concat(overlay.props.className || '');
      }

      if (this.popup) {
        if (this.popup.tagName) {
          cssText = this.popup.style && this.popup.style.cssText;
          popupProps.style = (0, _spauiUtils.objectAssign)((0, _index.getCssTextData)(cssText), {
            left: leftOfOverlay,
            top: topOfOverlay,
            display: show ? 'block' : 'none'
          });
        } else {
          popupProps.placement = placement;
          popupProps.show = show;
          popupProps.leftOfOverlay = leftOfOverlay;
          popupProps.topOfOverlay = topOfOverlay;
          popupProps.x = left;
          popupProps.y = top;
          popupProps.width = width;
          popupProps.height = height; // 展示了才计算

          if (show) {
            popupProps.arrowStyle = this.getArrowStyle();
          }
        }
      }

      popupProps.ref = function (el) {
        _this4.popup = el; // 方便回传节点给popup

        if (overlay && _typeof(overlay.props) === 'object' && (0, _spauiUtils.isFunction)(overlay.props.htmlref)) {
          overlay.props.htmlref(el);
        }
      };

      if (overlay && !overlay.tagName && !(overlay && overlay.type && overlay.type.componentName === 'spaui-popover') && typeof overlay.type === 'function') {
        popupProps.htmlref = popupProps.ref;
        popupProps.ref = null;
      } else {
        // 清除自定义属性htmlref
        if (typeof overlay.type !== 'string') {
          popupProps.htmlref = null;
        }
      }

      if (trigger === 'hover') {
        popupProps.onClick = function () {
          _this4._insideClick = true;
        };

        popupProps.onMouseOver = function () {
          clearTimeout(_this4.timeout);
        };

        popupProps.onMouseOut = this.handleMouseOut;
      } else if (trigger === 'click') {
        popupProps.onClick = function () {
          _this4._insideClick = true;
        };
      } // 如果是字符串，那就是原生dom结构，show需要是字符串的


      if (overlay && typeof overlay.type === 'string') {
        if (popupProps.show) {
          popupProps.show = popupProps.show.toString();
        } else {
          delete popupProps.show;
        }
      }

      return (0, _react.cloneElement)(overlay, popupProps);
    }
  }, {
    key: "isDefaultAligment",
    value: function isDefaultAligment() {
      return this.props.alignment === 'auto' && this.props.defaultAlignment === 'center';
    } // 获取popup的dom节点

  }, {
    key: "getPopupDom",
    value: function getPopupDom() {
      var popupRef = this.popup;
      var result = null; // 获取popup的dom节点

      if (popupRef) {
        if (popupRef.tagName) {
          result = popupRef;
        } else if (popupRef.getDOMNode) {
          result = popupRef.getDOMNode();
        }
      }

      return result;
    } // 如果指定了alignment并且使用的是PopOver的话，判断下是否要返回箭头style

  }, {
    key: "getArrowStyle",
    value: function getArrowStyle() {
      var alignmentProps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var _this$props6 = this.props,
          _this$props6$offsetDa = _this$props6.offsetData,
          offsetData = _this$props6$offsetDa === void 0 ? {} : _this$props6$offsetDa,
          _this$props6$placemen = _this$props6.placement,
          placement = _this$props6$placemen === void 0 ? '' : _this$props6$placemen;

      var _updateOffsetData = updateOffsetData(offsetData, this.state),
          _updateOffsetData$lef = _updateOffsetData.left,
          offsetLeft = _updateOffsetData$lef === void 0 ? 0 : _updateOffsetData$lef,
          _updateOffsetData$top = _updateOffsetData.top,
          offsetTop = _updateOffsetData$top === void 0 ? 0 : _updateOffsetData$top;

      var _this$state2 = this.state,
          width = _this$state2.width,
          height = _this$state2.height;

      var isEmptyObject = function isEmptyObject(data) {
        var result = false;

        if (_typeof(data) === 'object' && data) {
          if (Object.keys(data).length < 1) {
            result = true;
          }
        } else {
          result = true;
        }

        return result;
      };

      var result = {};
      var popupProps = {};
      var alignment = '';

      if (alignmentProps) {
        alignment = alignmentProps;
      } else {
        if (this.props.alignment === 'auto') {
          alignment = this.props.defaultAlignment || 'center';
        } else {
          alignment = this.props.alignment;
        }
      }

      if (this.popup && !this.popup.tagName) {
        popupProps = this.popup.props || {}; // 如果本身有自己指定popupStyle，那就使用自己指定的

        if (_typeof(popupProps.arrowStyle) === 'object' && popupProps.arrowStyle && !isEmptyObject(popupProps.arrowStyle)) {
          result = popupProps.arrowStyle;
        } else if (alignment) {
          // 对齐的时候才需要重新计算下箭头的位置
          if (placement === 'auto' || placement === 'bottom' || placement === 'top') {
            switch (alignment) {
              case 'left':
                if (width > 0) {
                  result.left = width / 2 - offsetLeft;
                }

                break;

              case 'right':
                if (width > 0) {
                  result.left = 'auto'; // 7px为箭头宽度的一半

                  result.right = width / 2 - 7 + offsetLeft;
                }

                break;
            }
          }

          if (placement === 'auto' || placement === 'left' || placement === 'right') {
            switch (alignment) {
              case 'top':
                if (height > 0) {
                  result.top = height / 2 - offsetTop;
                }

                break;

              case 'bottom':
                if (height > 0) {
                  result.top = 'auto'; // 7px为箭头宽度的一半

                  result.bottom = height / 2 - 7 + offsetTop;
                }

                break;
            }
          }
        }
      }

      return result;
    } // 根据最后的浮层位置来决定用哪个偏倚量

  }, {
    key: "getOffsetDataByPlacement",
    value: function getOffsetDataByPlacement() {
      var placement = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var _this$props$offsetDat = this.props.offsetData,
          offsetData = _this$props$offsetDat === void 0 ? {} : _this$props$offsetDat;
      var result = {
        left: 0,
        top: 0
      };

      switch (placement) {
        case 'left':
          result.left = parseInt(offsetData.placementLeft, 10) || 0;
          break;

        case 'right':
          result.left = parseInt(offsetData.placementRight, 10) || 0;
          break;

        case 'top':
          result.top = parseInt(offsetData.placementTop, 10) || 0;
          break;

        case 'bottom':
          result.top = parseInt(offsetData.placementBottom, 10) || 0;
          break;
      }

      return result;
    } // 设置浮层的位置(该函数不可去掉，可用于外部重新设置复层位置)

  }, {
    key: "setOverlay",
    value: function setOverlay(callback) {
      var _this$props7 = this.props,
          propsPlacement = _this$props7.placement,
          defaultPlacement = _this$props7.defaultPlacement,
          propsShow = _this$props7.show,
          positionTarget = _this$props7.positionTarget,
          _this$props7$offsetDa = _this$props7.offsetData,
          offsetData = _this$props7$offsetDa === void 0 ? {} : _this$props7$offsetDa,
          trigger = _this$props7.trigger,
          followMouse = _this$props7.followMouse,
          _this$props7$overlay = _this$props7.overlay,
          overlay = _this$props7$overlay === void 0 ? {} : _this$props7$overlay,
          _this$props7$autoPlac = _this$props7.autoPlacementBasic,
          autoPlacementBasic = _this$props7$autoPlac === void 0 ? '' : _this$props7$autoPlac,
          target = _this$props7.target;

      var _updateOffsetData2 = updateOffsetData(offsetData, this.state),
          _updateOffsetData2$le = _updateOffsetData2.left,
          offsetLeft = _updateOffsetData2$le === void 0 ? 0 : _updateOffsetData2$le,
          _updateOffsetData2$to = _updateOffsetData2.top,
          offsetTop = _updateOffsetData2$to === void 0 ? 0 : _updateOffsetData2$to;

      var _this$state3 = this.state,
          show = _this$state3.show,
          _this$state3$left = _this$state3.left,
          left = _this$state3$left === void 0 ? 0 : _this$state3$left,
          _this$state3$top = _this$state3.top,
          top = _this$state3$top === void 0 ? 0 : _this$state3$top,
          width = _this$state3.width,
          height = _this$state3.height;

      var _getClientSize = (0, _index.getClientSize)(),
          clientWidth = _getClientSize.clientWidth,
          clientHeight = _getClientSize.clientHeight;

      var popupDom = this.getPopupDom();
      var isFollowMouse = trigger === 'hover' && followMouse;
      var pageWidth = Math.max(document && document.body && document.body.scrollWidth, window && window.innerWidth);
      var overlayProps = overlay && _typeof(overlay) === 'object' ? overlay.props || {} : {};
      var gap = overlayProps.gap || 0;
      var winIsOk = (typeof window === "undefined" ? "undefined" : _typeof(window)) === 'object' && window;
      var placement = propsPlacement === 'auto' ? defaultPlacement : propsPlacement;
      var locationAndSizeOfChild = {};
      var leftOfChild = left;
      var topOfChild = top;
      var widthOfChild = width;
      var heightOfChild = height;
      var leftOfOverlay = 0;
      var topOfOverlay = 0;
      var popupRect = {};
      var popupWidth = 0;
      var popupHeight = 0;
      var alignment = '';
      var arrowStyle = {};
      var childRect = this.state.domRect;

      if (this.props.alignment === 'auto') {
        alignment = this.props.defaultAlignment || 'center';
      } else {
        alignment = this.props.alignment;
      } // 有结构且是展示中才需要处理


      if (popupDom && show) {
        popupRect = popupDom.getBoundingClientRect ? popupDom.getBoundingClientRect() : {};
        popupWidth = popupRect.width;
        popupHeight = popupRect.height; // 如果存在子结构，就用子结构的位置，子结构必须是原生dom

        if (typeof propsShow !== 'undefined' && this.childRef && this.childRef.tagName) {
          var positionTargetNode = this.childRef;

          if (positionTarget === 'parentNode' && this.childRef[positionTarget]) {
            positionTargetNode = this.childRef[positionTarget];
          }

          locationAndSizeOfChild = this.getLocationAndSizeOfDom(positionTargetNode);
          leftOfChild = locationAndSizeOfChild.left;
          topOfChild = locationAndSizeOfChild.top;
          widthOfChild = locationAndSizeOfChild.width;
          heightOfChild = locationAndSizeOfChild.height;
          childRect = locationAndSizeOfChild.domRect;
        } // followMouse的时候默认都以左上角为坐标原点


        if (isFollowMouse) {
          widthOfChild = 0;
          heightOfChild = 0;
        } // 如果是自动方向的，判断下是否有触碰到边界，触碰到就要换方向


        if (propsPlacement === 'auto') {
          if (placement === 'left') {
            if (leftOfChild - popupWidth < 0) {
              placement = 'right';
            }
          } else if (placement === 'right') {
            if (autoPlacementBasic === 'window' && childRect && winIsOk && window.innerWidth) {
              if (target === 'parentNode' && childRect.left > 0) {
                if (childRect.left + widthOfChild + popupWidth > window.innerWidth) {
                  placement = 'left';
                }
              } else if (leftOfChild + widthOfChild + popupWidth > window.innerWidth && popupWidth < leftOfChild) {
                placement = 'left';
              }
            } else {
              if (leftOfChild + widthOfChild + popupWidth > clientWidth) {
                placement = 'left';
              }
            }
          } else if (placement === 'bottom') {
            if (autoPlacementBasic === 'window' && childRect && winIsOk && window.innerHeight) {
              if (childRect.top + heightOfChild + popupHeight > window.innerHeight) {
                placement = 'top';
              }
            } else {
              if (topOfChild + heightOfChild + popupHeight > clientHeight) {
                placement = 'top';
              }
            }
          } else if (placement === 'top') {
            if (autoPlacementBasic === 'window' && childRect) {
              if (childRect.top - popupHeight < 0) {
                placement = 'bottom';
              }
            } else {
              if (topOfChild - popupHeight < 0) {
                placement = 'bottom';
              }
            }
          }
        } // 获取对应方向到位置


        if (placement === 'left') {
          leftOfOverlay = leftOfChild - popupWidth;
          topOfOverlay = (0, _index.getTopOfOverlay)(topOfChild, heightOfChild, popupHeight, alignment);
        } else if (placement === 'right') {
          leftOfOverlay = leftOfChild + widthOfChild;
          topOfOverlay = (0, _index.getTopOfOverlay)(topOfChild, heightOfChild, popupHeight, alignment);
        } else if (placement === 'top') {
          topOfOverlay = topOfChild - popupHeight;
          leftOfOverlay = (0, _index.getLeftOfOverlay)(leftOfChild, widthOfChild, popupWidth, alignment);
        } else {
          topOfOverlay = topOfChild + heightOfChild;
          leftOfOverlay = (0, _index.getLeftOfOverlay)(leftOfChild, widthOfChild, popupWidth, alignment);
        } // 如果是上下方向且没有调整alignment，如果碰到边缘了就采用左对齐或者右对齐的方式


        if ((placement === 'top' || placement === 'bottom') && !isFollowMouse && this.isDefaultAligment()) {
          if (leftOfOverlay < gap && leftOfOverlay > -5000) {
            leftOfOverlay = (0, _index.getLeftOfOverlay)(leftOfChild, widthOfChild, popupWidth, 'left');
            arrowStyle = this.getArrowStyle('left');

            if ((typeof arrowStyle.left === 'number' || arrowStyle.left) && this.popup && this.popup.arrowRef) {
              this.popup.arrowRef.style.left = "".concat(arrowStyle.left, "px");
            }
          } else if (leftOfOverlay + popupWidth > pageWidth - gap) {
            leftOfOverlay = (0, _index.getLeftOfOverlay)(leftOfChild, widthOfChild, popupWidth, 'right');
            arrowStyle = this.getArrowStyle('right');

            if ((typeof arrowStyle.right === 'number' || arrowStyle.right) && this.popup && this.popup.arrowRef) {
              this.popup.arrowRef.style.left = arrowStyle.left;
              this.popup.arrowRef.style.right = "".concat(arrowStyle.right, "px");
            }
          }
        }

        var offsetDataByPlacement = this.getOffsetDataByPlacement(placement);
        this.setState({
          left: Math.floor(leftOfChild),
          top: Math.floor(topOfChild),
          width: Math.floor(widthOfChild),
          height: Math.floor(heightOfChild),
          leftOfOverlay: Math.floor(leftOfOverlay + offsetLeft + offsetDataByPlacement.left),
          // 加上偏移量
          topOfOverlay: Math.floor(topOfOverlay + offsetTop + offsetDataByPlacement.top),
          // 加上偏移量
          placement: placement
        }, callback);
      }
    }
  }, {
    key: "renderPortal",
    value: function renderPortal() {
      (0, _reactDom.unstable_renderSubtreeIntoContainer)(this, // 代表当前组件
      this.popupContent(), // 塞进传送门的JSX
      this.el // 传送门另一端的DOM node
      );
    } // 获取尺寸跟位置

  }, {
    key: "getLocationAndSizeOfDom",
    value: function getLocationAndSizeOfDom(domNode) {
      var _this$props$fixed = this.props.fixed,
          fixed = _this$props$fixed === void 0 ? false : _this$props$fixed;
      var target = this.getTarget();
      var childRect = domNode && domNode.getBoundingClientRect && domNode.getBoundingClientRect() || {};
      var scrollTop = fixed ? 0 : (0, _index.getScrollTopOfDom)(target);
      var scrollLeft = fixed ? 0 : (0, _index.getScrollLeftOfDom)(target);
      var result = {};
      var targetRect = {};
      var targetTop = 0;
      var targetLeft = 0;

      if (target) {
        targetRect = target.getBoundingClientRect();

        if (typeof targetRect.top !== 'undefined' || typeof targetRect.y !== 'undefined') {
          targetTop = targetRect.top || targetRect.y || 0;
        }

        if (typeof targetRect.left !== 'undefined' || typeof targetRect.x !== 'undefined') {
          targetLeft = targetRect.left || targetRect.x || 0;
        }
      }

      result = {
        left: (childRect.left || childRect.x || 0) + scrollLeft - targetLeft,
        top: (childRect.top || childRect.y || 0) + scrollTop - targetTop,
        width: childRect.width,
        height: childRect.height,
        domRect: childRect
      };
      return result;
    }
  }, {
    key: "getDOMNode",
    value: function getDOMNode() {
      return this.childRef || null;
    } // 判断点击事件是否是键盘触发的
    // 比如对于 button 元素，当元素聚焦时，回车和空格都会导致触发 click 事件

  }, {
    key: "render",
    value: function render() {
      var _this5 = this;

      var _compactProps4 = (0, _overlay_trigger_compact_props["default"])(this.props),
          trigger = _compactProps4.trigger,
          propsShow = _compactProps4.show,
          _compactProps4$showDe = _compactProps4.showDelayTime,
          showDelayTime = _compactProps4$showDe === void 0 ? 0 : _compactProps4$showDe,
          triggerTarget = _compactProps4.triggerTarget,
          _compactProps4$goToPo = _compactProps4.goToPopOverDelayTime,
          goToPopOverDelayTime = _compactProps4$goToPo === void 0 ? 0 : _compactProps4$goToPo,
          _compactProps4$follow = _compactProps4.followMouse,
          followMouse = _compactProps4$follow === void 0 ? false : _compactProps4$follow,
          onShow = _compactProps4.onShow,
          triggerComponentClick = _compactProps4.onClick,
          _compactProps4$disabl = _compactProps4.disabled,
          disabled = _compactProps4$disabl === void 0 ? false : _compactProps4$disabl; // 如果禁用了就只返回children


      if (disabled) {
        return this.props.children;
      }

      var child = (0, _index.getChild)(this.props.children, (0, _overlay_trigger_compact_props["default"])(this.props)); // 点击触发元素

      var onTriggerTargetClick = function onTriggerTargetClick(event) {
        var eventTarget = event && event.target ? event.target : null;
        var targetParentNode = eventTarget && eventTarget.parentNode ? eventTarget.parentNode : null;
        var targetParentTagName = targetParentNode && targetParentNode.tagName ? targetParentNode.tagName.toLowerCase() : '';
        var targetTagName = eventTarget && eventTarget.tagName ? eventTarget.tagName.toLowerCase() : '';
        var targetClassName = eventTarget && eventTarget.className ? eventTarget.className : ''; // 如果是键盘触发的，忽略这次点击；如果是Switch的Input+Label触发的忽略

        if (_this5.isKeyDownClickEvent(event) || targetTagName === 'input' && targetParentTagName === 'label' && targetClassName.indexOf('spaui-switch-input') > -1) {
          event.stopPropagation(); // 设置为内部点击，使得 document 上的监听的 click 事件可以忽略此次点击

          _this5._insideClick = true;
          return;
        }

        var showResult = !_this5.state.show;

        var sizeAndPosition = _this5.getLocationAndSizeOfDom(event.currentTarget);

        var currentTarget = event.currentTarget;
        var target = event.target;

        var triggerClick = function triggerClick() {
          if (_this5 && _this5.setState) {
            var stateResult = sizeAndPosition;

            if (_this5.haveDocumentClick || !child && triggerTarget) {
              _this5._insideClick = true;
            }

            if (typeof propsShow === 'undefined') {
              stateResult.show = showResult;
            }

            _this5.setState(_objectSpread({}, stateResult));

            if ((0, _spauiUtils.isFunction)(childOnClick)) {
              childOnClick(event && event.target ? event : {
                target: target,
                currentTarget: currentTarget
              });
            }

            if ((0, _spauiUtils.isFunction)(triggerComponentClick)) {
              triggerComponentClick(event);
            }

            if ((0, _spauiUtils.isFunction)(onShow)) {
              onShow(event, showResult);
            }
          }
        };

        clearTimeout(_this5.showDelayTimeOut);

        if (showDelayTime > 0 && showResult) {
          _this5.showDelayTimeOut = setTimeout(triggerClick, showDelayTime);
        } else {
          triggerClick();
        }
      }; // mouseover触发元素


      var onTriggerTargetMouseOver = function onTriggerTargetMouseOver(event) {
        event && event.persist && event.persist();

        var sizeAndPosition = _this5.getLocationAndSizeOfDom(event.currentTarget);

        var showResult = true;
        var currentTarget = event.currentTarget;
        var target = event.target;

        var triggerMouseOver = function triggerMouseOver() {
          if (_this5 && _this5.setState) {
            var stateResult = sizeAndPosition;
            clearTimeout(_this5.timeout);

            if (typeof propsShow === 'undefined') {
              stateResult.show = showResult;
            }

            _this5.setState(stateResult);

            if ((0, _spauiUtils.isFunction)(childOnMouseOver)) {
              childOnMouseOver(event && event.target ? event : {
                target: target,
                currentTarget: currentTarget
              });
            }

            if ((0, _spauiUtils.isFunction)(onShow)) {
              onShow(event, showResult);
            }
          }
        };

        if (showDelayTime > 0 && showResult) {
          clearTimeout(_this5.timeout);
          clearTimeout(_this5.showDelayTimeOut);
          _this5.showDelayTimeOut = setTimeout(triggerMouseOver, showDelayTime);
        } else {
          triggerMouseOver();
        }
      };

      var triggerProps = {};
      var childProps = {};
      var childOnMouseOver;
      var childOnClick;

      if (_typeof(child) === 'object' && child) {
        // children有内容就以children为触发点
        childProps = child.props;
        childOnMouseOver = childProps.onMouseOver;
        childOnClick = childProps.onClick;

        if (trigger === 'click') {
          triggerProps.onClick = onTriggerTargetClick;
        } else if (trigger === 'hover') {
          triggerProps.onMouseOver = onTriggerTargetMouseOver;

          triggerProps.onMouseOut = function (event) {
            _this5.handleMouseOut(event, goToPopOverDelayTime);
          };

          if (followMouse) {
            triggerProps.onMouseMove = function (event) {
              var moveX = 0;
              var moveY = 0;
              var rect = null;

              if (event && event.currentTarget && event.currentTarget.getBoundingClientRect) {
                rect = event.currentTarget.getBoundingClientRect();
              }

              if (rect && event && typeof event.clientX !== 'undefined') {
                moveX = event.clientX - rect.left;
                moveY = event.clientY - rect.top;

                _this5.setState({
                  moveX: moveX,
                  moveY: moveY
                });
              }
            };
          }

          triggerProps.onClick = function (event) {
            if (_this5.haveDocumentClick || !child && triggerTarget) {
              _this5._insideClick = true;
            }

            if ((0, _spauiUtils.isFunction)(childOnClick)) {
              childOnClick(event);
            }

            if ((0, _spauiUtils.isFunction)(triggerComponentClick)) {
              triggerComponentClick(event);
            }
          };
        }

        if (!child.tagName && (0, _spauiUtils.isFunction)(child.type)) {
          triggerProps.ref = function (el) {
            // hack: 用于React15获取children的node节点
            var getNodeByReactInternalInstance = function getNodeByReactInternalInstance(elInstance) {
              if (_typeof(elInstance) === 'object') {
                if (elInstance._renderedComponent) {
                  getNodeByReactInternalInstance(elInstance._renderedComponent);
                } else {
                  if (elInstance._hostNode && elInstance._hostNode.tagName) {
                    node = elInstance._hostNode;
                  }
                }
              }
            }; // hack: 用于React16获取children的node节点


            var getNodeByReactInternalFiber = function getNodeByReactInternalFiber(elInstance) {
              if (_typeof(elInstance) === 'object') {
                if (elInstance.child) {
                  getNodeByReactInternalFiber(elInstance.child);
                } else {
                  if (elInstance.stateNode && elInstance.stateNode.tagName) {
                    node = elInstance.stateNode;
                  }
                }
              }
            };

            var node = null;

            if (el) {
              getNodeByReactInternalInstance(el._reactInternalInstance);

              if (!node) {
                getNodeByReactInternalFiber(el._reactInternalFiber);
              }

              if (node) {
                _this5.childRef = node;
              }
            }
          };

          triggerProps.htmlref = function (el) {
            _this5.childRef = el; // 方便回传节点给popup

            if ((0, _spauiUtils.isFunction)(childProps.htmlref)) {
              childProps.htmlref(el);
            }
          };

          triggerProps.htmlRef = triggerProps.htmlref;
        } else {
          triggerProps.ref = function (el) {
            _this5.childRef = el; // 方便回传节点给popup

            if ((0, _spauiUtils.isFunction)(childProps.htmlref)) {
              childProps.htmlref(el);
            }
          }; // 清除自定义属性htmlref


          if (typeof child.type !== 'string') {
            triggerProps.htmlref = null;
          }
        }

        triggerProps.key = "".concat(this.id, "child");

        if (typeof _reactDom.createPortal === 'undefined') {
          return (0, _react.cloneElement)(child, triggerProps);
        } // 因为renderToString不支持createPortal所以要特殊hack一下
        // process.env.SSR 指明是在SSR


        if ((typeof process === "undefined" ? "undefined" : _typeof(process)) === 'object' && process && _typeof(process.env) === 'object' && process.env.SSR) {
          return (0, _react.cloneElement)(child, triggerProps);
        }

        return [(0, _react.cloneElement)(child, triggerProps), (0, _reactDom.createPortal)(this.popupContent(), this.el)];
      }

      if (triggerTarget && triggerTarget.tagName) {
        // 指定的触发对象
        if (trigger === 'click') {
          triggerTarget.onclick = onTriggerTargetClick;
        } else if (trigger === 'hover') {
          triggerTarget.onmouseover = onTriggerTargetMouseOver;

          triggerTarget.onmouseout = function (event) {
            _this5.handleMouseOut(event, goToPopOverDelayTime);
          };
        }

        this.childRef = triggerTarget;

        if (typeof _reactDom.createPortal === 'undefined') {
          return null;
        } // 因为renderToString不支持createPortal所以要特殊hack一下
        // process.env.SSR 指明是在SSR


        if ((typeof process === "undefined" ? "undefined" : _typeof(process)) === 'object' && process && _typeof(process.env) === 'object' && process.env.SSR) {
          return null;
        }

        return (0, _reactDom.createPortal)(this.popupContent(), this.el);
      }

      return null;
    }
  }]);

  return OverlayTrigger;
}(_react.PureComponent);

_defineProperty(OverlayTrigger, "propTypes", _overlay_trigger_props.propTypes);

_defineProperty(OverlayTrigger, "defaultProps", _overlay_trigger_props.defaultProps);

var _default = OverlayTrigger;
exports["default"] = _default;